import { message, Upload } from 'antd';
import { forwardRef, ReactNode, useCallback, useImperativeHandle, useRef } from 'react';
import axios from 'axios';
import { create32LengthUUID } from '@/utils/index';
import { apiGetTempUploadUrl } from '@/services/OssRequest';
import {
  EVideoSource,
  EVideoUploadStatus,
  TVideNode,
} from '@/pages/backend/cardCampSettings/nodeSettings/videoCom/videoNode';
import { RcFile } from 'antd/es/upload';
import { toInteger } from 'lodash';

const maxCount = 9999;

const VideoUpload = forwardRef<
  any,
  {
    children: ReactNode;
    onChange: (file: Omit<TVideNode, 'index'>) => void;
  }
>((props, ref) => {
  const uploadFileMapping = useRef<Record<string, any>>({});
  const { children, onChange } = props;
  const fileNameFun = useCallback((file: { name: string }) => {
    const type = file.name.slice(file.name.lastIndexOf('.') + 1); // 获取文件名中的后缀名
    return `${create32LengthUUID()}.${type}`;
  }, []);
  const onError = (file: any, option: any) => {
    console.log('执行了onError');
    // option.onError('上传失败请稍后重试');
    onChange({
      id: file.uid,
      name: file.name,
      source: EVideoSource.self_upload,
      size: file.size,
      uploadStatus: EVideoUploadStatus.fail,
    });
  };

  const uploadFile = async (file: any, option?: any) => {
    // 获取视频时长
    const url = URL.createObjectURL(file);
    const videoElement = document.createElement('video');
    videoElement.src = url;
    videoElement.addEventListener('canplay', function () {
      onChange({
        id: file.uid,
        name: file.name,
        source: EVideoSource.self_upload,
        duration: Math.round(this.duration),
        size: file.size,
        resolution: this.videoWidth + 'x' + this.videoHeight,
        uploadStatus: EVideoUploadStatus.loading,
      });
      URL.revokeObjectURL(url);
    });

    const fileName = fileNameFun(file);
    onChange({
      id: file.uid,
      name: file.name,
      source: EVideoSource.self_upload,
      uploadStatus: EVideoUploadStatus.loading,
      uploadPercentage: 0,
    });
    try {
      const tempUrl = await apiGetTempUploadUrl({
        path: 'myfr/camp/video',
        fileName: fileName,
        contentType: file.type,
      });
      if (tempUrl?.data?.signedUrl) {
        const {
          data: { signedUrl, actualSignedRequestHeaders },
        } = tempUrl;
        axios
          .request({
            method: 'PUT',
            url: signedUrl,
            withCredentials: false,
            headers:
              Object.assign(actualSignedRequestHeaders, {
                'Content-Disposition': `attachment; filename=${encodeURIComponent(file.name)}`,
              }) || {},
            data: file,
            onUploadProgress: (progressEvent) => {
              console.log('progressEvent', progressEvent);
              if (progressEvent.lengthComputable && progressEvent.total) {
                const percentage = toInteger((progressEvent.loaded / progressEvent.total) * 100);
                onChange({
                  id: file.uid,
                  name: file.name,
                  source: EVideoSource.self_upload,
                  uploadStatus: EVideoUploadStatus.loading,
                  uploadPercentage: percentage,
                });
              }
            },
          })
          .then(async (result) => {
            console.log('上传的结果是');
            console.log(result);
            const uploadUrl = `https://shequ-oss.obs.cn-east-2.myhuaweicloud.com:443/myfr/camp/video/${fileName}`;
            option?.onSuccess(uploadUrl);
            onChange({
              id: file.uid,
              name: file.name,
              url: uploadUrl,
              source: EVideoSource.self_upload,
              uploadStatus: EVideoUploadStatus.success,
            });
          })
          .catch(() => {
            onError(file, option);
          });
      } else {
        onError(file, option);
      }
    } catch (e) {
      console.log('出错了', e);
      onError(file, option);
    }
  };
  const handleUpload = async (option: any) => {
    console.log('handleupload option', option);
    const file = option.file as RcFile;
    uploadFile(file, option);
  };
  useImperativeHandle(ref, () => {
    return {
      retry: (item: any) => {
        console.log(item);
        console.log(uploadFileMapping.current);
        const fileId = item.id;
        if (fileId in uploadFileMapping.current) {
          uploadFile(uploadFileMapping.current[fileId]);
        } else {
          message.warning('未找到文件 无法重试');
        }
      },
    };
  });
  return (
    <Upload
      multiple
      listType={'picture'}
      fileList={[]}
      maxCount={maxCount}
      name="file"
      accept=".mp4,.mov,.wmv,.flv,.avi,.webm,.mkv"
      customRequest={handleUpload}
      beforeUpload={(file, fileList) => {
        console.log('beforeUpload');
        console.log(fileList);
        const isLt4GB = file.size / 1024 / 1024 / 1024 <= 4;
        if (!isLt4GB) {
          message.error('文件大小最大为4GB');
          return false;
        }
        if (file.uid) {
          uploadFileMapping.current[file.uid] = file;
        }
        return true;
      }}
    >
      {children}
    </Upload>
  );
});
export default VideoUpload;
